module.exports = __webpack_public_path__ + "static/media/poly.b0cec2da.jpg";